import React, { useEffect, useRef, useState } from 'react'
import { View, TouchableOpacity, Dimensions, Image, Platform, Pressable } from 'react-native'
import PropTypes from 'prop-types'
// import { RNCamera } from 'react-native-infy-camera'
// import { RNHoleView } from 'react-native-hole-view'
// import ImageEditor from '@react-native-community/image-editor'

// import RNFS from 'react-native-fs'

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components'

import { Images } from '../../Themes'

import styles from './CameraStep.Styles'

import { getThemeImages, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

const fileToBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const base64 = reader.result
      resolve(base64)
    }
  })

}


const { width: SCREEN_WIDTH } = Dimensions.get('screen')


const cameraSteps = {
  first: 'first',
  second: 'second',
  third: 'third',
}


const FirstStep = ({
  setActiveIndex,
  toggleCameraModal,
  frontIdPhoto,
  setFrontIdPhoto,
  setFrontIdPhotoBase64
}) => {

  const cameraRef = useRef()

  const theme = useTheme()

  const uplodad = () => {
    cameraRef.current.click()
  }
  const images = getThemeImages(theme.name)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View>
        <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
          <VFText
            style={{ textAlign: 'center', flex: 1, fontSize: 22, fontWeight: 700, lineHeight: 22, }}
            i18nKey={'renewals_camera_front_id'}
          />
          <Pressable style={{ alignSelf: 'flex-end' }} onPress={() => { toggleCameraModal(false) }}>
            {/* <Icon
              name={images.ic_arrow_left}
              /> */}
            <Icon
              name={images.ic_close}
              size={24}
              type={'image'}
            />
          </Pressable>
        </View>
        <input
          ref={cameraRef}
          type="file"
          name="myImage"
          style={{ visibility: 'hidden' }}
          onChange={async (event) => {
            if (event.target.files[0].type.split('/')[0] === 'image') {
              const base64 = await fileToBase64(event.target.files[0])
              setFrontIdPhotoBase64(base64)
              setFrontIdPhoto(base64)
              // setSelectedImage(event.target.files[0]);
            }
          }}
        />
        {frontIdPhoto ?
          <View style={styles.borderRadius(400, 400, 0)}>
            <Image
              source={{ uri: frontIdPhoto }}
              style={styles.image(400, 400)}
              resizeMode="contain"
            />
          </View> :
          <View style={{ width: 400, height: 400, alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
            <VFText
              i18nKey='no_preview'
              style={{ fontSize: 22, fontWeight: 700, textAlign: 'center' }}
            />
          </View>
        }
        <View style={{ flexDirection: 'row' }}>
          <VFButton
            onPress={uplodad}
            type="primary"
            title={Boolean(frontIdPhoto) ? 'upload_another' : 'upload'}
            style={{ marginRight: 10, flex: 1 }}
          />
          <VFButton
            disabled={!Boolean(frontIdPhoto)}
            onPress={() => { setActiveIndex(cameraSteps.second) }}
            type="secondary"
            title='go_to_next_step'
            style={{ marginleft: 10, flex: 1 }}
          />
        </View>
      </View>)
  }
  return (
    <View style={{ backgroundColor: theme.colors.quickActionGradientColors.secondary }}>
      <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
        <VFText
          style={{ textAlign: 'center', flex: 1, fontSize: 22, fontWeight: 700, lineHeight: 22, }}
          i18nKey={'renewals_camera_front_id'}
        />
        <Pressable style={{ alignSelf: 'flex-end' }} onPress={() => { toggleCameraModal(false) }}>
          {/* <Icon
    name={images.ic_arrow_left}
    /> */}
          <Icon
            name={images.ic_close}
            size={24}
            type={'image'}
          />
        </Pressable>
      </View>
      <input
        ref={cameraRef}
        capture="environment"
        type="file"
        name="myImage"
        style={{ visibility: 'hidden' }}
        onChange={async (event) => {
          if (event.target.files[0].type.split('/')[0] === 'image') {
            const base64 = await fileToBase64(event.target.files[0])
            setFrontIdPhotoBase64(base64)
            setFrontIdPhoto(base64)
            // setSelectedImage(event.target.files[0]);
          }
        }}
      />
      {frontIdPhoto ?
        <View style={styles.borderRadius(400, 400, 0)}>
          <Image
            source={{ uri: frontIdPhoto }}
            style={styles.image(400, 400)}
            resizeMode="contain"
          />
        </View> :
        <View style={{ width: 400, height: 400, alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
          <VFText
            i18nKey='no_preview'
            style={{ fontSize: 22, fontWeight: 700, textAlign: 'center' }}
          />
        </View>
      }
      <View style={{ flexDirection: 'row' }}>
        <VFButton
          onPress={uplodad}
          type="primary"
          title={Boolean(frontIdPhoto) ? 'upload_another' : 'upload'}
          style={{ marginRight: 10, flex: 1 }}
        />
        <VFButton
          disabled={!Boolean(frontIdPhoto)}
          onPress={() => { setActiveIndex(cameraSteps.second) }}
          type="secondary"
          title='go_to_next_step'
          style={{ marginleft: 10, flex: 1 }}
        />
      </View>
    </View>
  )
}

FirstStep.propTypes = {
  setActiveIndex: PropTypes.func,
  toggleCameraModal: PropTypes.func,
  frontIdPhoto: PropTypes.string,
  setFrontIdPhoto: PropTypes.func,
  setFrontIdPhotoBase64: PropTypes.func,
}


const SecondStep = ({
  setActiveIndex,
  toggleCameraModal,
  backIdPhoto,
  setBackIdPhoto,
  setBackIdPhotoBase64,
}) => {
  const cameraRef = useRef()

  const uplodad = () => {
    cameraRef.current.click()
  }
  const themeName = useTheme().name

  const images = getThemeImages(themeName)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View>
        <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
          <Pressable onPress={() => { setActiveIndex(cameraSteps.first) }}>
            <Icon
              name={images.ic_arrow_left}
              size={24}
              type={'image'}
            />
          </Pressable>
          <VFText
            style={{ textAlign: 'center', flex: 1, fontSize: 22, fontWeight: 700, lineHeight: 22, }}
            i18nKey={'renewals_camera_back_id'}
          />
          <Pressable style={{ alignSelf: 'flex-end' }} onPress={() => { toggleCameraModal(false) }}>

            <Icon
              name={images.ic_close}
              size={24}
              type={'image'}
            />
          </Pressable>
        </View>
        <input
          ref={cameraRef}
          type="file"
          name="myImage"
          style={{ visibility: 'hidden' }}
          onChange={async (event) => {
            if (event.target.files[0].type.split('/')[0] === 'image') {
              const base64 = await fileToBase64(event.target.files[0])
              setBackIdPhotoBase64(base64)
              setBackIdPhoto(base64)
              // setSelectedImage(event.target.files[0]);
            }
          }}
        />
        {backIdPhoto ?
          <View style={styles.borderRadius(400, 400, 0)}>
            <Image
              source={{ uri: backIdPhoto }}
              style={styles.image(400, 400)}
              resizeMode="contain"
            />
          </View> :
          <View style={{ width: 400, height: 400, alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
            <VFText
              i18nKey='no_preview'
              style={{ fontSize: 22, fontWeight: 700, textAlign: 'center' }}
            />
          </View>
        }
        <View style={{ flexDirection: 'row' }}>
          <VFButton
            onPress={uplodad}
            type="primary"
            title={Boolean(backIdPhoto) ? 'upload_another' : 'upload'}
            style={{ marginRight: 10, flex: 1 }}
          />
          <VFButton
            disabled={!Boolean(backIdPhoto)}
            onPress={() => { setActiveIndex(cameraSteps.third) }}
            type="secondary"
            title='go_to_next_step'
            style={{ marginleft: 10, flex: 1 }}
          />
        </View>
      </View>
    )
  }


  return (
    <View>
      <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
        <Pressable onPress={() => { setActiveIndex(cameraSteps.first) }}>
          <Icon
            name={images.ic_arrow_left}
            size={24}
            type={'image'}
          />
        </Pressable>
        <VFText
          style={{ textAlign: 'center', flex: 1, fontSize: 22, fontWeight: 700, lineHeight: 22, }}
          i18nKey={'renewals_camera_back_id'}
        />
        <Pressable style={{ alignSelf: 'flex-end' }} onPress={() => { toggleCameraModal(false) }}>

          <Icon
            name={images.ic_close}
            size={24}
            type={'image'}
          />
        </Pressable>
      </View>
      <input
        ref={cameraRef}
        type="file"
        capture="environment"
        name="myImage"
        style={{ visibility: 'hidden' }}
        onChange={async (event) => {
          if (event.target.files[0].type.split('/')[0] === 'image') {
            const base64 = await fileToBase64(event.target.files[0])
            setBackIdPhotoBase64(base64)
            setBackIdPhoto(base64)
            // setSelectedImage(event.target.files[0]);
          }
        }}
      />
      {backIdPhoto ?
        <View style={styles.borderRadius(400, 400, 0)}>
          <Image
            source={{ uri: backIdPhoto }}
            style={styles.image(400, 400)}
            resizeMode="contain"
          />
        </View> :
        <View style={{ width: 400, height: 400, alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
          <VFText
            i18nKey='no_preview'
            style={{ fontSize: 22, fontWeight: 700, textAlign: 'center' }}
          />
        </View>
      }
      <View style={{ flexDirection: 'row' }}>
        <VFButton
          onPress={uplodad}
          type="primary"
          title={Boolean(backIdPhoto) ? 'upload_another' : 'upload'}
          style={{ marginRight: 10, flex: 1 }}
        />
        <VFButton
          disabled={!Boolean(backIdPhoto)}
          onPress={() => { setActiveIndex(cameraSteps.third) }}
          type="secondary"
          title='go_to_next_step'
          style={{ marginleft: 10, flex: 1 }}
        />
      </View>
    </View>
  )
}

SecondStep.propTypes = {
  setActiveIndex: PropTypes.func,
  toggleCameraModal: PropTypes.func,
  backIdPhoto: PropTypes.string,
  setBackIdPhoto: PropTypes.func,
  setBackIdPhotoBase64: PropTypes.func,
}


const ThirdStep = ({
  toggleCameraModal,
  selfie,
  setSelfie,
  setSelfieBase64,
}) => {

  const themeName = useTheme().name


  const images = getThemeImages(themeName)

  const cameraRef = useRef()


  const uplodad = () => {
    cameraRef.current.click()
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View>
        <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
          <VFText
            style={{ textAlign: 'center', flex: 1, fontSize: 22, fontWeight: 700, lineHeight: 22, }}
            i18nKey={'renewals_camera_selfie'}
          />
          <Pressable style={{ alignSelf: 'flex-end' }} onPress={() => { toggleCameraModal(false) }}>
            {/* <Icon
                  name={images.ic_arrow_left}
                  /> */}
            <Icon
              name={images.ic_close}
              size={24}
              type={'image'}
            />
          </Pressable>
        </View>
        <input
          ref={cameraRef}
          type="file"
          name="myImage"
          style={{ visibility: 'hidden' }}
          onChange={async (event) => {
            if (event.target.files[0].type.split('/')[0] === 'image') {
              const base64 = await fileToBase64(event.target.files[0])
              setSelfie(base64)
              setSelfieBase64(base64)
              // setSelectedImage(event.target.files[0]);
            }
          }}
        />
        {selfie ?
          <View style={styles.borderRadius(400, 400, 0)}>
            <Image
              source={{ uri: selfie }}
              style={styles.image(400, 400)}
              resizeMode="contain"
            />
          </View> :
          <View style={{ width: 400, height: 400, alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
            <VFText
              i18nKey='no_preview'
              style={{ fontSize: 22, fontWeight: 700, textAlign: 'center' }}
            />
          </View>
        }
        <View style={{ flexDirection: 'row' }}>
          <VFButton
            onPress={uplodad}
            type="primary"
            title={Boolean(selfie) ? 'upload_another' : 'upload'}
            style={{ marginRight: 10, flex: 1 }}
          />
          <VFButton
            disabled={!Boolean(selfie)}
            onPress={() => { toggleCameraModal(false) }}
            type="secondary"
            title='go_to_next_step'
            style={{ marginleft: 10, flex: 1 }}
          />
        </View>
      </View>
    )
  }

  return (
    <View>
      <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
        <VFText
          style={{ textAlign: 'center', flex: 1, fontSize: 22, fontWeight: 700, lineHeight: 22, }}
          i18nKey={'renewals_camera_selfie'}
        />
        <Pressable style={{ alignSelf: 'flex-end' }} onPress={() => { toggleCameraModal(false) }}>
          {/* <Icon
          name={images.ic_arrow_left}
          /> */}
          <Icon
            name={images.ic_close}
            size={24}
            type={'image'}
          />
        </Pressable>
      </View>
      <input
        ref={cameraRef}
        type="file"
        capture="user"
        name="myImage"
        style={{ visibility: 'hidden' }}
        onChange={async (event) => {
          if (event.target.files[0].type.split('/')[0] === 'image') {
            const base64 = await fileToBase64(event.target.files[0])
            setSelfie(base64)
            setSelfieBase64(base64)
            // setSelectedImage(event.target.files[0]);
          }
        }}
      />
      {selfie ?
        <View style={styles.borderRadius(400, 400, 0)}>
          <Image
            source={{ uri: selfie }}
            style={styles.image(400, 400)}
            resizeMode="contain"
          />
        </View> :
        <View style={{ width: 400, height: 400, alignItems: 'center', justifyContent: 'center', alignSelf: 'center' }}>
          <VFText
            i18nKey='no_preview'
            style={{ fontSize: 22, fontWeight: 700, textAlign: 'center' }}
          />
        </View>
      }
      <View style={{ flexDirection: 'row' }}>
        <VFButton
          onPress={uplodad}
          type="primary"
          title={Boolean(selfie) ? 'upload_another' : 'upload'}
          style={{ marginRight: 10, flex: 1 }}
        />
        <VFButton
          disabled={!Boolean(selfie)}
          onPress={() => { toggleCameraModal(false) }}
          type="secondary"
          title='go_to_next_step'
          style={{ marginleft: 10, flex: 1 }}
        />
      </View>
    </View>
  )
}

ThirdStep.propTypes = {
  toggleCameraModal: PropTypes.func,
  selfie: PropTypes.string,
  setSelfie: PropTypes.func,
  setSelfieBase64: PropTypes.func,
}


const steps = {
  first: FirstStep,
  second: SecondStep,
  third: ThirdStep,
}


const CameraStep = ({
  toggleCameraModal,
  frontIdPhoto,
  setFrontIdPhoto,
  backIdPhoto,
  setBackIdPhoto,
  selfie,
  setSelfie,
  setFrontIdPhotoBase64,
  setBackIdPhotoBase64,
  setSelfieBase64,
}) => {

  const [activeIndex, setActiveIndex] = useState(frontIdPhoto ? (backIdPhoto ? cameraSteps.third : cameraSteps.second) : cameraSteps.first)

  const Step = steps[activeIndex]

  return (
    <Step
      setActiveIndex={setActiveIndex}
      toggleCameraModal={toggleCameraModal}
      frontIdPhoto={frontIdPhoto}
      setFrontIdPhoto={setFrontIdPhoto}
      backIdPhoto={backIdPhoto}
      setBackIdPhoto={setBackIdPhoto}
      selfie={selfie}
      setSelfie={setSelfie}
      setFrontIdPhotoBase64={setFrontIdPhotoBase64}
      setBackIdPhotoBase64={setBackIdPhotoBase64}
      setSelfieBase64={setSelfieBase64}
    />
  )
}

CameraStep.propTypes = {
  toggleCameraModal: PropTypes.func,
  frontIdPhoto: PropTypes.string,
  setFrontIdPhoto: PropTypes.func,
  backIdPhoto: PropTypes.string,
  setBackIdPhoto: PropTypes.func,
  selfie: PropTypes.string,
  setSelfie: PropTypes.func,
  setFrontIdPhotoBase64: PropTypes.func,
  setBackIdPhotoBase64: PropTypes.func,
  setSelfieBase64: PropTypes.func,
}

export default CameraStep
